"use client";

import { localeCodes, usePathname, useRouter } from "@/i18n/routing";
import Image from "next/image";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";
import { IMAGE_SIZES } from "@/lib/imageSizes";

type LanguageSwitcherProps = {
  currentLocale: string;
  version?: "short" | "full";
};

const LanguageSwitch: React.FC<LanguageSwitcherProps> = ({
  currentLocale,
  version = "short",
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const [locale, setLocale] = useState(currentLocale);

  useEffect(() => {
    setLocale(currentLocale);
  }, [currentLocale]);

  return (
    <Select
      value={locale}
      onValueChange={(val) => {
        setLocale(val);
        const articleRegex = /\/resource\/category\/[^/]+\/[^/]+/;
        if (articleRegex.test(pathname)) {
          const newPath = pathname.replace(/\/[^/]+$/, "");
          router.replace(newPath, { locale: val as any });
          return;
        }

        const termRegex = /\/resource\/glossary\/term\/[^/]+/;
        if (termRegex.test(pathname)) {
          const newPath = pathname.replace(/\/[^/]+$/, "");
          router.replace("/resource/glossary", { locale: val as any });
          return;
        }

        router.replace(pathname, { locale: val as any });
      }}
    >
      <SelectTrigger aria-label="Select language" className="min-w-24 max-w-48">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {localeCodes.map((item) => (
          <SelectItem key={item.locale} value={item.locale}>
            <div className="flex flex-row gap-2 items-center">
              <Image
                src={item.flag}
                alt={item.name}
                width={50}
                height={50}
                unoptimized
                sizes={IMAGE_SIZES.icon16}
                className="w-4 h-4"
              />
              <span className="font-medium">
                {version === "short" ? item.locale.toUpperCase() : item.name}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitch;
